import {buildSelectCashConditions, buildSelectOptions, removeTableRow} from "./shared";

export function prepareDenomSelectInput(data) {
    const currencyElem = $('select').filter('[id="denomination"]');
    currencyElem.empty();
    for (let i=0; i<data.length; i++) {
        currencyElem.append('<option value="' + data[i].id + '">' + data[i].name + '</option>');
    }
}

//Mutilated Deposit
export function redoMutilatedDenomsTable(data) {
    var elem = $('#requestMutilatedDataTable > tbody');
    elem.empty();
    elem.append(mutilatedDenomRow(data));
}

export function addMutilatedDenomRow(data) {
    $('#addMutilatedDenomBtn').on('click', function (e) {
        e.preventDefault();
        $('#requestMutilatedDataTable > tbody').append(mutilatedDenomRow(data));
        removeTableRow();
    });
}

export function mutilatedDenomRow(data) {
    return  `
                <tr> 
                    <td> 
                        <select name="denom" required class="form-control">
                            <option value="">Choose</option>
                            ${buildSelectOptions(data)}
                        </select>
                    </td> 
                    <td> 
                        <select name="mutilatedValue" required class="form-control">
                            <option value="">Choose</option>
                            <option value="FULL">FULL</option>
                            <option value="HALF">HALF</option>
                            <option value="ZERO">ZERO</option>
                        </select>
                    </td> 
                    <td>
                        <input type="number" min="1" step="1" required name="denomCount" class="form-control" />
                    </td> 
                    <td>
                        <button class="btn btn-sm btn-danger remove-btn"><i class="fas fa-trash"></i> Remove</button>
                    </td> 
                </tr>
                `
}

//Deposits Denoms
export function redoDenomsTable(data) {
    var elem = $('#requestDataTable > tbody');
    elem.empty();
    elem.append(denomTableRow(data));
}

export function addDenomRow(data) {
    let hasCashConditions = $('#cashConditionHeader').length;
    $('#addDenomBtn').on('click', function (e) {
        e.preventDefault();
        $('#requestDataTable > tbody').append(denomTableRow(data, hasCashConditions));
        removeTableRow();
    });
}

export function denomTableRow(data, hasCashConditions = false) {
    var str = hasCashConditions ? `<td>${buildSelectCashConditions()}</td>` : null;
    return `<tr> 
                    <td> 
                        <select name="denom" required class="form-control">
                            <option value="">Choose</option>
                            ${buildSelectOptions(data)}
                        </select>
                    </td> 
                    ${str}
                    <td><input type="number" min="0.01" step="0.01" required name="denomCount" class="form-control" /></td> 
                    <td><button class="btn btn-sm btn-danger remove-btn"><i class="fas fa-trash"></i> Remove</button></td> 
                </tr>`;
}

